/**
 * InheritedBadge - TASK-376
 * Shared badge component indicating a field value was auto-populated
 * from approved KYC data rather than manually entered.
 */

import React from 'react';
import { ArrowDownCircle } from 'lucide-react';

export const InheritedBadge: React.FC = () => (
  <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium bg-blue-50 text-blue-600 border border-blue-200 rounded ml-2">
    <ArrowDownCircle className="w-2.5 h-2.5" />
    inherited
  </span>
);

export default InheritedBadge;
